import styled from 'styled-components';

export const SettingUpProfileAnimationStyles = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  gap: 16px;

  .process {
    &-data {
      margin: 0 0 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-progress {
      width: 100%;
      height: 8px;
      background: #262130;
      border-radius: 8px;
      position: relative;

      &-bar {
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: 100%;
        background: linear-gradient(126deg, #7f36f3 21.37%, #ed0d80 105.25%);
        border-radius: 8px;
      }
    }
  }
`;
